'use client'
import { GearIcon } from '@radix-ui/react-icons'
import { useUserStore } from '~/app/_store/user-store'
import { useTeamReplicache } from '~/hooks-data/use-team-replicache'
import { useDashboardSlugs } from '~/hooks/use-dashboard-slugs'
import { ButtonLink } from '~/sotano-kit/primitives/button'

export const SidebarLayout = ({ children }: { children?: React.ReactNode }) => {
  const { teamSlug } = useDashboardSlugs()
  const { data, isLoading } = useTeamReplicache()
  const optimisticUser = useUserStore((s) => s.optimisticUser)

  const isTeamMember =
    data &&
    data.team &&
    optimisticUser &&
    data.team.members.some((m) => m.userId === optimisticUser?.id)
  return (
    <div className="flex flex-col gap-4 mt-8 pt-8 border-t border-dark-border xl:mt-0 xl:pt-0 xl:border-t-0 w-full min-w-0 gap-y-6 grow-0 shrink-0 xl:basis-[352px] mx-0">
      <div className="flex justify-between">
        <h2 className="text-base leading-[26px] font-medium">About</h2>
        {isTeamMember && !isLoading && (
          <ButtonLink
            intent="secondary"
            href={`${teamSlug}/settings`}
            icon={<GearIcon className="size-3.5" />}
          >
            Settings
          </ButtonLink>
        )}
      </div>
      <div className="flex flex-col gap-6">{children}</div>
    </div>
  )
}
